import leafletMap from "../../../../src/scripts/components/leaflet-map";

window.addEventListener( 'DOMContentLoaded', () => leafletMap( "map" ) );
